import { render, staticRenderFns } from "./DestroyedObjects.vue?vue&type=template&id=60c9bbae&scoped=true&"
import script from "./DestroyedObjects.vue?vue&type=script&lang=js&"
export * from "./DestroyedObjects.vue?vue&type=script&lang=js&"
import style0 from "./DestroyedObjects.vue?vue&type=style&index=0&id=60c9bbae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c9bbae",
  null
  
)

export default component.exports